export const MAX_POINTS = 8;
// EW-1063: hard bound on a data-point label so a pathological (60+ char) label
// cannot be stored/rendered. Flag-gated; when OFF the input is uncapped as before.
export const LABEL_MAX = 40;
export const PRESET_REFS = [
  "suggested_color_0",
  "suggested_color_1",
  "suggested_color_2",
  "suggested_color_3",
  "suggested_color_4",
  "suggested_color_5",
];

export const fieldStyle = {
  width: "100%",
  boxSizing: "border-box",
  height: 34,
  border: "1px solid #CED4DA",
  borderRadius: 4,
  padding: "5px 10px",
  fontSize: 12,
  fontFamily: "'DM Sans', sans-serif",
  outline: "none",
};

// gordon-0915-graph-block-data-points-drag-reorder
export const GRAPH_ROW_DND_TYPE = "graph-data-point-row";
